import React from 'react';

function Footer() {
  return (
    <footer className="footer page__section">
      <p className="footer__copyright">
        © 2021 Mesto Russia
      </p>
    </footer>
  );
}

export default Footer;
